const MESSAGE_TYPES = {
  TEXT: 1,
  IMAGE: 2,
  TEXT_IMAGE: 3,
  NOTIFICATION: 4,
  SPIN: 5,
  POCKET_MONEY: 6,
  AUTO_REPLY: 7,
};

export default MESSAGE_TYPES;
